import { SetStateAction } from "react";
import { useState } from "react";
import { ModalWithButtons } from "./modal";
import { BlueButton, WhiteButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";
import { CustomTextInput } from "../inputs";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function DiscardOrderConfirmModal(props: Props) {
	const { t: translation } = useTranslation();
	const [userInput, setUserInput] = useState("");

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<WhiteButton
					key="discard-order-cancel-button"
					id="discard-order-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></WhiteButton>,
				<BlueButton
					key="discard-order-proceed-button"
					id="discard-order-proceed-button"
					children={translation("Discard")}
					disabled={userInput !== translation("Discard")}
					onClick={() => {
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></BlueButton>,
			]}
		>
			<div className="modal-body-content">
				<div className="modal-body-icon discard-order-icon"></div>

				<div className="typography-body-01 typography-bold">
					{translation("Discardorder?")}
				</div>
				<div
					className="typography-body-01"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("DiscardConfirmMessage")}
				</div>
				<div
					className="typography-body-01"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("CannotUndoAction")}
				</div>
				<div
					style={{
						marginTop: "5px",
					}}
				>
					<CustomTextInput
						id="discard-order-confirm-input"
						label={""}
						value={userInput}
						setValue={setUserInput}
						placeholder={translation("Discard")}
						required
					/>
				</div>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
